import React from 'react';
import { Instagram, Menu, X } from 'lucide-react';
import { siteInfo } from '../data/mock';

const Header = ({ isMenuOpen, setIsMenuOpen }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#fffef2]/95 backdrop-blur-sm border-b border-[#bcbbb4]/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo - Solo nombre */}
          <button
            onClick={() => scrollToSection('inicio')}
            className="font-display text-xl font-light tracking-[0.15em] text-[#333] hover:text-[#666] transition-colors"
          >
            {siteInfo.name}
          </button>

          {/* Desktop Navigation - Simplificado a 4 items */}
          <nav className="hidden lg:flex items-center gap-10">
            <button
              onClick={() => scrollToSection('sobre-mi')}
              className="nav-link font-body text-sm font-normal text-[#333] tracking-wide"
            >
              Sobre mí
            </button>
            <button
              onClick={() => scrollToSection('novias')}
              className="nav-link font-body text-sm font-normal text-[#333] tracking-wide"
            >
              Novias
            </button>
            <button
              onClick={() => scrollToSection('galeria')}
              className="nav-link font-body text-sm font-normal text-[#333] tracking-wide"
            >
              Galería
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="nav-link font-body text-sm font-normal text-[#333] tracking-wide"
            >
              Contacto
            </button>
          </nav>

          {/* Desktop Social - Solo Instagram */}
          <div className="hidden lg:flex items-center">
            <a
              href={siteInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#333] hover:text-[#666] transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={20} strokeWidth={1.5} />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-[#333]"
            aria-label="Menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="lg:hidden bg-[#fffef2] border-t border-[#bcbbb4]/30">
          <nav className="flex flex-col px-6 py-6 gap-6">
            <button
              onClick={() => scrollToSection('sobre-mi')}
              className="text-left font-body text-sm text-[#333] tracking-wide"
            >
              Sobre mí
            </button>
            <button
              onClick={() => scrollToSection('novias')}
              className="text-left font-body text-sm text-[#333] tracking-wide"
            >
              Novias
            </button>
            <button
              onClick={() => scrollToSection('galeria')}
              className="text-left font-body text-sm text-[#333] tracking-wide"
            >
              Galería
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="text-left font-body text-sm text-[#333] tracking-wide"
            >
              Contacto
            </button>
            <div className="flex items-center gap-6 pt-4 border-t border-[#bcbbb4]/30">
              <a
                href={siteInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-[#333]"
              >
                <Instagram size={18} strokeWidth={1.5} />
                {siteInfo.instagramHandle}
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
